import { message } from 'antd'
import { URL_ENDPOINT_USER } from './constants/config.user'
import {
  DetailUserInput,
  ListUserInput,
  ListUserNotInProjectInput,
  ListUserNotInTaskInput,
  UserEntity,
} from '../../../../server-api-hrm.type'
import { MetadataType } from '../../../../utils/metadata.types'
import axiosClient from '../../../../utils/custom-fetch'

const appEndpoint = URL_ENDPOINT_USER

export const getListUser = async (token?: string, body?: ListUserInput) => {
  if (!token) {
    message.error('Thông tin không hợp lệ')
    return null
  }

  try {
    return await axiosClient(token).post<{
      metadata: MetadataType
      data: UserEntity[]
    }>(`${appEndpoint}/list`, body)
  } catch {
    message.error('Tải dữ liệu thất bại')
  }

  return null
}

export const getListUserNotInProject = async (
  token?: string,
  body?: Partial<ListUserNotInProjectInput>
) => {
  if (!token || !body?.projectId) {
    message.error('Thông tin không hợp lệ')
    return null
  }

  try {
    return await axiosClient(token).post<{
      metadata: MetadataType
      data: UserEntity[]
    }>(`${appEndpoint}/list/not-in-project`, body)
  } catch {
    message.error('Tải dữ liệu thất bại')
  }

  return null
}

export const getListUserNotInTask = async (
  token?: string,
  body?: Partial<ListUserNotInTaskInput>
) => {
  if (!token || !body?.taskId) {
    message.error('Thông tin không hợp lệ')
    return null
  }

  try {
    return await axiosClient(token).post<{
      metadata: MetadataType
      data: UserEntity[]
    }>(`${appEndpoint}/list/not-in-task`, body)
  } catch {
    message.error('Tải dữ liệu thất bại')
  }

  return null
}

export const getDetailUser = async (token?: string, body?: DetailUserInput) => {
  if (!body?.id || !token) {
    message.error('Thông tin không hợp lệ')
    return null
  }

  try {
    return await axiosClient(token).post<UserEntity>(
      `${appEndpoint}/detail`,
      body
    )
  } catch {
    message.error('Tải dữ liệu thất bại')
  }

  return null
}

export const getCurrentUser = async (token?: string) => {
  if (!token) {
    message.error('Thông tin không hợp lệ')
    return null
  }

  try {
    return await axiosClient(token).post<UserEntity>(`${appEndpoint}/whoami`)
  } catch {
    message.error('Tải dữ liệu thất bại')
  }

  return null
}
